import React from 'react';
import registerData from '../../data/event-register.json';

const hero = registerData.hero;

export default function EventHero() {
    return (
        <section className="er-hero">
            <style>{`
                .er-hero {
                    position: relative;
                    min-height: 70vh;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    padding: 150px 0 80px;
                    background: var(--eventflow-black);
                }
                .er-hero__bg {
                    position: absolute; inset: 0;
                    background-image: url('${process.env.PUBLIC_URL}/hero%20background.jpeg');
                    background-size: cover;
                    background-position: center;
                    z-index: 0;
                }
                .er-hero__overlay {
                    position: absolute; inset: 0;
                    background: linear-gradient(110deg,
                        rgba(4,0,10,0.88) 0%,
                        rgba(4,0,10,0.70) 50%,
                        rgba(4,0,10,0.50) 100%);
                    z-index: 1;
                }
                /* grid lines */
                .er-hero::after {
                    content: '';
                    position: absolute; inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none;
                    z-index: 2;
                }
                .er-hero__inner {
                    position: relative; z-index: 3;
                }
                .er-hero__tag {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base);
                    margin-bottom: 20px;
                }
                .er-hero__tag::before, .er-hero__tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .er-hero__title {
                    font-family: var(--eventflow-font);
                    font-size: 64px; font-weight: 900;
                    color: #fff; line-height: 1.05;
                    letter-spacing: -2px; margin-bottom: 20px;
                    text-transform: uppercase;
                }
                .er-hero__title span {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .er-hero__sub {
                    font-family: var(--eventflow-font);
                    font-size: 17px; color: rgba(255,255,255,0.6);
                    max-width: 580px; margin-bottom: 40px; line-height: 1.75;
                }
                .er-hero__meta {
                    display: flex; flex-wrap: wrap; gap: 16px; margin-bottom: 40px;
                }
                .er-hero__meta-item {
                    display: inline-flex; align-items: center; gap: 8px;
                    background: rgba(255,255,255,0.05);
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 50px; padding: 9px 20px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.65);
                }
                .er-hero__meta-item i { color: var(--eventflow-base); font-size: 13px; }
                .er-hero__meta-item strong { color: #fff; font-weight: 600; }
                .er-hero__btns { display: flex; gap: 14px; flex-wrap: wrap; }

                @media (max-width: 768px) {
                    .er-hero { padding: 130px 0 60px; min-height: auto; }
                    .er-hero__title { font-size: 40px; letter-spacing: -1px; }
                }
            `}</style>

            <div className="er-hero__bg" />
            <div className="er-hero__overlay" />

            <div className="container">
                <div className="er-hero__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="er-hero__tag">{hero.tag}</div>
                    <h1 className="er-hero__title">
                        {hero.title}<span>{hero.titleAccent}</span><br />{hero.titleLine2}
                    </h1>
                    <p className="er-hero__sub">
                        {hero.subtitle}
                    </p>
                    <div className="er-hero__meta">
                        {(hero.meta || []).map((item, i) => (
                            <span className="er-hero__meta-item" key={i}>
                                <i className={`fa ${item.icon}`} /><strong>{item.text}</strong>
                            </span>
                        ))}
                    </div>
                    <div className="er-hero__btns">
                        {(hero.buttons || []).map((btn, i) => (
                            <a key={i} href={btn.link} className={btn.style === 'primary' ? 'thm-btn' : 'thm-btn-outline'}>
                                {btn.text} <span className="icon-arrow-right" />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
